import { useReactiveVar } from "@apollo/client";
import { mobileAppModel } from "../../state";
import {
  Language,
  useGetLanguagesQuery,
} from "../../../../../generated/graphql";
import { Autocomplete } from "@material-ui/lab";
import { ModalInput } from "../../../../shared/Style/Style";

export const SelectLanguage = () => {
  const model = useReactiveVar(mobileAppModel.model);
  const inputErrors = useReactiveVar(mobileAppModel.inputErrors);
  const isLoading = useReactiveVar(mobileAppModel.updateLoading);
  const { data, loading } = useGetLanguagesQuery();

  const languages = data?.getLanguages ?? [];

  if (loading) return null;

  return (
    <Autocomplete
      disabled={isLoading}
      options={languages.map(({ id }) => id)}
      value={model?.language?.id}
      onChange={(_, value) =>
        mobileAppModel.setLanguage(languages.find(({ id }) => id === value) as Language)
      }
      onFocus={() => mobileAppModel.setInputErrors("language", false)}
      getOptionLabel={(option) =>
        languages.find(({ id }) => id === option)?.displayName
      }
      renderInput={(params) => {
        return (
          <ModalInput
            {...params}
            error={inputErrors.language.error}
            margin="normal"
            fullWidth
            label="Мова"
            required
          />
        );
      }}
    />
  );
};